import React, { PropTypes } from 'react';
import { get } from 'lodash';
import Status from './StatusComponent';
import { Uplift } from '../../../../constants/ManageApps';
import { SAVE_LEVEL } from '../../../../constants/Level';
import StatusMessage from './StatusMessageComponent';
import ConfigurationCheckbox from 'components/widgets/ConfigurationCheckbox';
import If from '../../../helpers/if';
import { isActive } from './utils';

const UpliftSection = ({ configurationObject, chainConfigurationObject, isDisabled, level, setValue }) => {
    const status = get(configurationObject, 'status');
    const chainStatus = get(chainConfigurationObject, 'status');
    const isInherit = status === 'inherit';
    const disableForPartialDepositRates = _.get(isInherit ? chainConfigurationObject : configurationObject, 'disableForPartialDepositRates');
    const isActiveStatus = isActive(level, status, chainStatus);
    const isCheckboxDisabled = level === SAVE_LEVEL.HOTEL && isInherit;

    return (
        <section className="content-section">
            <Status
                isDisabled={isDisabled}
                objectName="uplift"
                value={status}
                parentValue={chainStatus}
                level={level}
                setValue={(key, value) => {
                    setValue(key, value);
                }}
                appName={Uplift.appName}
            />
            <If condition={isActiveStatus}>
                <ConfigurationCheckbox
                    title="Disable Flexpay for partial deposit rates"
                    isDisabled={isCheckboxDisabled}
                    code="uplift.disableForPartialDepositRates"
                    onChange={(key, value) => {
                        setValue(key, !value);
                    }}
                    value={disableForPartialDepositRates}
                />
            </If>
            <StatusMessage appName={Uplift.appName} value={status} parentValue={chainStatus} />
        </section>
    );
};

UpliftSection.propTypes = {
    configurationObject: PropTypes.shape({}),
    chainConfigurationObject: PropTypes.shape({}),
    isDisabled: PropTypes.bool,
    level: PropTypes.string,
    setValue: PropTypes.func
};

export default UpliftSection;




// WEBPACK FOOTER //
// ./src/components/pages/manage/apps/UpliftSection.js